/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_HowInputs */

const en_directory_ai_tools_eyebrow_how = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three steps`)
};

const zh_directory_ai_tools_eyebrow_how = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三步完成`)
};

/**
* | output |
* | --- |
* | "Three steps" |
*
* @param {Directory_Ai_Tools_Eyebrow_HowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_how = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_HowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_HowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_how(inputs)
	return zh_directory_ai_tools_eyebrow_how(inputs)
});
export { directory_ai_tools_eyebrow_how as "directory.ai_tools.eyebrow.how" }